import { Fragment, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { AppBar, Avatar, Box, Drawer, IconButton, List, ListItem, ListItemIcon, ListItemText, makeStyles, Toolbar, Typography } from '@material-ui/core';
import { deepPurple } from '@material-ui/core/colors';
import { AccountCircle as AccountIcon } from '@material-ui/icons';
import { authenticationService } from '../../services';

const drawerWidth = 255;

const useStyles = makeStyles((theme) => ({
  appBar: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    background: '#B3B3B3',
    background: 'rgba(179, 179, 179, 1)'
  },
  avatar: {
    color: theme.palette.getContrastText(deepPurple[500]),
    backgroundColor: '#6D6E71',
    marginRight: theme.spacing(2),
  },
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(3),
    marginLeft: drawerWidth,
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0
  },
  drawerPaper: {
    width: drawerWidth,
    backgroundColor: theme.palette.grey[800],
    background: 'linear-gradient(60deg, rgba(128, 128, 128, 1) 0%, rgba(92, 92, 92, 1) 39.44%, rgba(62, 62, 62, 1) 78.06%, rgba(51, 51, 51, 1) 100%);',
    color: theme.palette.getContrastText(theme.palette.grey[800])
  },
  toolbar: {
    minHeight: '80px',
    paddingLeft: '55px'
  }
}));

export default function MainLayout(props) {
  const classes = useStyles();

  const history = useHistory();

  const { children } = props;

  const [user, setUser] = useState(null);

  useEffect(() => {
    getUser();
  }, []);

  async function getUser() {
    const data = await authenticationService.getUser();
    setUser(data);
  };

  return (
    <Fragment>
      <AppBar
        className={classes.appBar}
        position="static"
      >
        <Toolbar
          className={classes.toolbar}
        >
          <Avatar className={classes.avatar} color="inherit">S</Avatar>
          <Box display="flex" flexDirection="column" flexGrow={1}>
            <Typography variant="subtitle2" color="primary">SILICA</Typography>
            <Typography variant="body2">{user?.name}</Typography>
          </Box>
          <IconButton color="primary" onClick={() => history.push('logout')}>
            <AccountIcon fontSize="normal" />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Drawer
        className={classes.drawer}
        variant="permanent"
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div className={classes.toolbar} />
        <List>
          {['Dashboard', 'Support', 'Other'].map((text, index) => (
            <ListItem button key={text} selected={text === 'Dashboard'}>
              <ListItemIcon />
              <ListItemText primary={text} />
            </ListItem>
          ))}
        </List>
      </Drawer>
      <main className={classes.content}>
        {children}
      </main>
    </Fragment>
  );
}